import style from "./style";

class NotAvaliable {
  template() {
    return `
      <a class='${style.study}'>
        Estudar
      </a>
    `;
  }

  static async create() {
    return NotAvaliable();
  }
}

export default NotAvaliable;
